<template>
  <div class="nix-forgot-form">
    <h2 class="nix-forgot-form__title">Esqueceu a senha?</h2>
    <p class="nix-forgot-form__text">
      Informe o E-mail associado a sua conta, enviaremos um link com as instruções.
    </p>

    <Alert type="success" v-if="showSuccess">
      <span>Pronto! Enviamos o link de redefinição. Confira a pasta de spam se não encontrar.</span>
    </Alert>

    <InputText
      v-model="email"
      title="E-mail"
      :formName="formName"
      field="email"
      :required="true"
      :maxLength="100"
    >
      <div class="glyphicon"><i class="fa-solid fa-envelope"></i></div>
    </InputText>

    <Button
      _key="send"
      type="primary"
      title="Enviar"
      classIcon="fa-solid fa-paper-plane"
      size="medium"
      :disabled="!isFormValid(formName)"
      :clicked="handleForgotPassword"
    />

    <span class="nix-forgot-form__link" @click="$emit('back-to-login')">
      Voltar ao login
    </span>
  </div>
</template>

<script>
import InputText from '@/ui/forms/InputText.vue'
import Button from '@/ui/forms/Button.vue'
import Alert from '@/ui/layout/Alert.vue'
import { authService } from '@/modules/auth/services/auth.service'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'LoginForgotPassword',
  components: { InputText, Button, Alert },
  data() {
    return {
      formName: 'forgot',
      email: '',
      showSuccess: false,
    }
  },
  computed: {
    ...mapGetters('validation', ['isFormValid']),
  },
  methods: {
    ...mapMutations('generic', ['removeLoading']),
    async handleForgotPassword() {
      this.showSuccess = false
      try {
        const response = await authService.forgotPassword({ email: this.email })
        if (response && response.data && response.data.success) {
          this.showSuccess = true
        }
      } catch (e) {
        // erros tratados por Messages via generic/postApi
      } finally {
        this.removeLoading(['send'])
      }
    },
  },
}
</script>

<style scoped>
.nix-forgot-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.nix-forgot-form__title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
  color: var(--text-primary);
}

.nix-forgot-form__text {
  margin: -8px 0 0;
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
  color: var(--text-secondary);
}

.nix-forgot-form__link {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  letter-spacing: 0.5px;
  text-align: center;
  color: var(--color-brand);
  cursor: pointer;
}

.nix-forgot-form__link:hover {
  color: var(--color-brand-hover);
  text-decoration: underline;
}

.glyphicon {
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
  top: 50%;
  padding-top: 0;
  transform: translateY(-50%);
}

@media (max-width: 480px) {
  .nix-forgot-form__title { font-size: 19px; }
}
</style>
